import React, {useState} from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import FadeIn from './FadeIn';

const faqs = [
  {q: "Where is Padua Hills Theatre located?", a: "We are nestled in the scenic foothills at 4467 Padua Ave, Claremont, CA 91711, serving Los Angeles County and Southern California."},
  {q: "Is Padua an indoor or outdoor wedding venue?", a: "Both! We offer flexible indoor and outdoor spaces, including our Plaza Courtyard for outdoor ceremonies, the Sunset-View Terrace for cocktail hours, and our historic indoor Ballroom for receptions."},
  {q: "Does Padua offer catering?", a: "Yes, we provide an elevated, flexible catering experience tailored for elegant dinners and culturally diverse celebrations. We handle the culinary details to ensure a seamless guest experience."},
  {q: "How many guests can Padua host?", a: "Our versatile estate spaces comfortably accommodate both intimate gatherings and grand celebrations, typically hosting up to 250 guests depending on the specific event layout."},
  {q: "How do I inquire about a wedding or event?", a: "The best way is to fill out our brief inquiry form below. We will get back to you promptly to discuss date availability, pricing, and scheduling a private tour."},
];

const BG = "https://ik.imagekit.io/aeu02xvjgn/i-Wh5HSCQ-X3.jpg?updatedAt=1776890015711";

const FAQ = () => {
  const [openIdx, setOpenIdx] = useState(null);

  return (
    <section
      className="py-24 md:py-32 relative px-6"
      style={{
        backgroundImage: `url('${BG}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'scroll',
      }}
    >
      <div className="absolute inset-0 bg-brand-charcoal/70" />
      <div className="max-w-3xl mx-auto relative z-10">
        <FadeIn className="text-center mb-16">
          <span className="text-brand-bronze uppercase tracking-[0.3em] text-[10px] font-semibold mb-4 block">Details</span>
          <h2 className="font-serif text-3xl md:text-4xl text-brand-vintage font-light">Common Questions</h2>
          <div className="w-16 h-[1px] bg-brand-stone/50 mx-auto mt-6" />
        </FadeIn>
        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <FadeIn key={idx} delay={idx * 0.08}>
              <div className="border border-brand-vintage/20 bg-brand-charcoal/50 backdrop-blur-sm">
                <button
                  className="w-full flex justify-between items-center p-5 md:p-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-bronze"
                  onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                  aria-expanded={openIdx === idx}
                >
                  <span className="font-serif text-base md:text-lg text-brand-vintage pr-4">{faq.q}</span>
                  <SafeIcon
                    icon={FiIcons.FiChevronDown}
                    className={`text-brand-bronze shrink-0 transition-transform duration-400 ${openIdx === idx ? 'rotate-180' : ''}`}
                  />
                </button>
                <div className={`overflow-hidden transition-all duration-400 ease-in-out ${openIdx === idx ? 'max-h-60 opacity-100' : 'max-h-0 opacity-0'}`}>
                  <p className="px-5 pb-5 md:px-6 md:pb-6 font-sans text-brand-vintage/70 font-light text-sm leading-relaxed border-t border-brand-vintage/10 pt-4">
                    {faq.a}
                  </p>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQ;